
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexOOQywg6K3CyTJUt5zcMMIFgElLm3pIYu0jaCqQ6TTIcMeta } from "/builds/henry/yuelai-engine-blog-web/pages/index.vue?macro=true";
import { default as _91name_93eLAsA3_9PY_MJ362krlDpLqiOEttxowz6ZdOHHCSxxoMeta } from "/builds/henry/yuelai-engine-blog-web/pages/tag/[name].vue?macro=true";
import { default as _91slug_93_46htmlg7x3NmMX3mpUX9b8FWCCq3_45kRNPVCG_45tQ3Gyy7vqCBoMeta } from "/builds/henry/yuelai-engine-blog-web/pages/[slug].html.vue?macro=true";
import { default as indexN__EI_6JVyIUuqY2JQnEH1nIs_PRgElahGd0Evq7DfwMeta } from "/builds/henry/yuelai-engine-blog-web/pages/links/index.vue?macro=true";
import { default as _91slug_93oLdAWVaFWY9V6qrnl1OaBrx5MzEpR99gXyMfcKD2zwkMeta } from "/builds/henry/yuelai-engine-blog-web/pages/page/[slug].vue?macro=true";
import { default as _91slug_93w7zbiDAj4C9Hf1Lso7vmBhv_45cJmAy_45pKqbF17MMk9GQMeta } from "/builds/henry/yuelai-engine-blog-web/pages/post/[slug].vue?macro=true";
import { default as index3mPQO0v4QDVns9ARJHpBAUvcvUDXTAE6_qF5xpTPuDwMeta } from "/builds/henry/yuelai-engine-blog-web/pages/tweet/index.vue?macro=true";
import { default as index63iNe49lFGZl6B_bdbkgm1F1dsZSI1O3OSc4j6RxeFMMeta } from "/builds/henry/yuelai-engine-blog-web/pages/albums/index.vue?macro=true";
import { default as _91slug_93SiuSG_T2MFwaqidp2_ZhNIkK9NM1CG6aXVvhPlRLyUYMeta } from "/builds/henry/yuelai-engine-blog-web/pages/albums/[slug].vue?macro=true";
import { default as _91_46_46_46permalink_93zqD7Nl0WfE9iZLGXYAuigwLYQ_qpXY9o6U0ACB7JzbIMeta } from "/builds/henry/yuelai-engine-blog-web/pages/[...permalink].vue?macro=true";
import { default as indexf0QYQCJSSqvHogPzOcsoAuh67kiH8WKDd936jhptpfsMeta } from "/builds/henry/yuelai-engine-blog-web/pages/archives/index.vue?macro=true";
import { default as _91slug_93616hdRsOwkAlA65O_iXdfTVziphVLpEJUnwKVvYxnCEMeta } from "/builds/henry/yuelai-engine-blog-web/pages/category/[slug].vue?macro=true";
import { default as _91slug_93_46htmlLj_ZaNEjpmsFRW47pbJJDzlhBBUzkKPbSXDQ7xshiYYMeta } from "/builds/henry/yuelai-engine-blog-web/pages/archives/[slug].html.vue?macro=true";
import { default as indexgtT8jICFoRMqSE_45o8oca4eBsgNsY9EYW_45vqr1DRN_hkMeta } from "/builds/henry/yuelai-engine-blog-web/pages/archives/[slug]/index.vue?macro=true";
import { default as _91slug_93_46htmlIH8vfkoskjJ2WSIr78Tom8x_45KhvY8QDyQjMDG5TVovMMeta } from "/builds/henry/yuelai-engine-blog-web/pages/[category]/[slug].html.vue?macro=true";
import { default as _91month_93sFd1VgCURvoNVD1LyH2XUch5wPeky0i8V9JpshSJSaEMeta } from "/builds/henry/yuelai-engine-blog-web/pages/archives/[year]/[month].vue?macro=true";
import { default as _91_46_46_46directory_93KXtanofN2g4AlsYtPFo2w_458go7ehYS6s68AFU7fvzpgMeta } from "/builds/henry/yuelai-engine-blog-web/pages/category/[...directory].vue?macro=true";
import { default as _91slug_93_46htmlAUo8fzgRMDbMwBu_cT39R8klRA7rkFaDKCajbKQ3MhsMeta } from "/builds/henry/yuelai-engine-blog-web/pages/[year]/[month]/[day]/[slug].html.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/builds/henry/yuelai-engine-blog-web/pages/index.vue")
  },
  {
    name: "tag-name",
    path: "/tag/:name()",
    component: () => import("/builds/henry/yuelai-engine-blog-web/pages/tag/[name].vue")
  },
  {
    name: "slug.html",
    path: "/:slug().html",
    component: () => import("/builds/henry/yuelai-engine-blog-web/pages/[slug].html.vue")
  },
  {
    name: "links",
    path: "/links",
    component: () => import("/builds/henry/yuelai-engine-blog-web/pages/links/index.vue")
  },
  {
    name: "page-slug",
    path: "/page/:slug()",
    component: () => import("/builds/henry/yuelai-engine-blog-web/pages/page/[slug].vue")
  },
  {
    name: "post-slug",
    path: "/post/:slug()",
    component: () => import("/builds/henry/yuelai-engine-blog-web/pages/post/[slug].vue")
  },
  {
    name: "tweet",
    path: "/tweet",
    component: () => import("/builds/henry/yuelai-engine-blog-web/pages/tweet/index.vue")
  },
  {
    name: "albums",
    path: "/albums",
    component: () => import("/builds/henry/yuelai-engine-blog-web/pages/albums/index.vue")
  },
  {
    name: "albums-slug",
    path: "/albums/:slug()",
    component: () => import("/builds/henry/yuelai-engine-blog-web/pages/albums/[slug].vue")
  },
  {
    name: "permalink",
    path: "/:permalink(.*)*",
    component: () => import("/builds/henry/yuelai-engine-blog-web/pages/[...permalink].vue")
  },
  {
    name: "archives",
    path: "/archives",
    component: () => import("/builds/henry/yuelai-engine-blog-web/pages/archives/index.vue")
  },
  {
    name: "category-slug",
    path: "/category/:slug()",
    component: () => import("/builds/henry/yuelai-engine-blog-web/pages/category/[slug].vue")
  },
  {
    name: "archives-slug.html",
    path: "/archives/:slug().html",
    component: () => import("/builds/henry/yuelai-engine-blog-web/pages/archives/[slug].html.vue")
  },
  {
    name: "archives-slug",
    path: "/archives/:slug()",
    meta: indexgtT8jICFoRMqSE_45o8oca4eBsgNsY9EYW_45vqr1DRN_hkMeta || {},
    component: () => import("/builds/henry/yuelai-engine-blog-web/pages/archives/[slug]/index.vue")
  },
  {
    name: "category-slug.html",
    path: "/:category()/:slug().html",
    component: () => import("/builds/henry/yuelai-engine-blog-web/pages/[category]/[slug].html.vue")
  },
  {
    name: "archives-year-month",
    path: "/archives/:year()/:month()",
    component: () => import("/builds/henry/yuelai-engine-blog-web/pages/archives/[year]/[month].vue")
  },
  {
    name: "category-directory",
    path: "/category/:directory(.*)*",
    component: () => import("/builds/henry/yuelai-engine-blog-web/pages/category/[...directory].vue")
  },
  {
    name: "year-month-day-slug.html",
    path: "/:year()/:month()/:day()/:slug().html",
    component: () => import("/builds/henry/yuelai-engine-blog-web/pages/[year]/[month]/[day]/[slug].html.vue")
  }
]